/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { ButtonPrimary } from '../../../../../../utils/Button';
import cn from '../../../../../../utils/cn';

const limitByArr = [
    {
        key: 'duration',
        title: 'Duration'
    },
    {
        key: 'ppu',
        title: 'Pay Per Unit'
    },
    {
        key: 'lifetime',
        title: 'Life Time'
    }
];

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`value-text line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item, handleEditClick, handleSelectPackage }) {
    const [isActive, setIsActive] = useState(false);

    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsActive(!isActive)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-80': isActive,
                    'max-h-10': !isActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.packageName}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span
                        className={`line-clamp-1 capitalize ${
                            item?.status === 'active' ? 'text-success' : 'text-warning'
                        }`}
                    >
                        {item?.status}
                    </span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard
                    name="Limit By"
                    value={limitByArr.find((el) => el.key === item?.limitBy)?.title}
                />

                <TableInfoCard name="Role" value={item?.role} isCapitalize />
                <TableInfoCard name="Total Price" value={item?.prices?.length || 0} />
                <TableInfoCard
                    name="Public"
                    value={item?.isPublic ? 'Yes' : 'No'}
                    className={
                        item?.isPublic
                            ? '[&>.value-text]:text-success'
                            : '[&>.value-text]:text-warning'
                    }
                />

                <TableInfoCard
                    name="Status"
                    value={item?.status}
                    isCapitalize
                    className={`sm:hidden ${item?.status === 'active' ? '[&>.value-text]:text-success' : '[&>.value-text]:text-warning'}`}
                />

                <div className="flex flex-row gap-px justify-end items-center">
                    <ButtonPrimary
                        btnType="button"
                        title="View"
                        onClick={(ev) => handleSelectPackage(ev, item)}
                        className="h-7 min-w-14 text-sm"
                    />
                    <ButtonPrimary
                        btnType="button"
                        title="Edit"
                        onClick={(ev) => handleEditClick(ev, item)}
                        className="h-7 min-w-14 text-sm"
                    />
                </div>
            </div>
        </div>
    );
}

function TableMobile({ data, handleEditClick, handleSelectPackage }) {
    return (
        <div className="packages_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data && data?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.map((item) => (
                        <TableRow
                            key={item.id}
                            item={item}
                            handleEditClick={handleEditClick}
                            handleSelectPackage={handleSelectPackage}
                        />
                    ))
                )}
            </div>
        </div>
    );
}

export default TableMobile;
